import { Input } from 'antd';
import React from 'react';

export const rgMask = (value) =>
  value
    .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada


export function InputRg({
  className,
  value,
  onChange,
  disabled,
  placeholder,
  prefix,
  max
}){

  function handleChange(e) {
    const { value: rg } = e.target;
    const novoRg =  rgMask(rg);
    if(novoRg.length > max ){
      return;
    }
    onChange(novoRg);
  }

  return (
    <Input
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      prefix={prefix}
      className={className}
    />
  );

}
